
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import { getDeploymentInfo } from './utils/routingUtils.ts';

// Global error handling
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

// Route change monitoring
const monitorRouteChanges = () => {
  let lastPath = window.location.pathname;
  
  // Listen for history changes
  window.addEventListener('popstate', () => {
    const currentPath = window.location.pathname;
    console.log(`Route changed from ${lastPath} to ${currentPath}`);
    lastPath = currentPath;
  });
  
  // Enhance history pushState and replaceState
  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;
  
  window.history.pushState = function() {
    originalPushState.apply(this, arguments);
    console.log(`Route pushed to ${arguments[2]}`);
    dispatchEvent(new Event('popstate'));
  };
  
  window.history.replaceState = function() {
    originalReplaceState.apply(this, arguments);
    console.log(`Route replaced with ${arguments[2]}`);
    dispatchEvent(new Event('popstate'));
  };
};

// Use beforeunload instead of unload for cleanup operations
window.addEventListener('beforeunload', () => {
  console.log('Application is about to unload - performing cleanup');
  // Any cleanup operations can go here
});

// Get detailed deployment information
const deploymentInfo = getDeploymentInfo();

// Initialize the app with correct routing configuration
console.log('----------- APPLICATION INITIALIZATION -----------');
console.log('Initializing app with hostname:', window.location.hostname);
console.log('Full URL:', window.location.href);
console.log('Pathname:', window.location.pathname);
console.log('Environment:', import.meta.env.MODE);
console.log('Base URL:', import.meta.env.BASE_URL);
console.log('Deployment platform:', deploymentInfo.platform);
console.log('Deployment environment:', deploymentInfo.environment);
console.log('Deployment type:', deploymentInfo.deployType);
console.log('-----------------------------------------------');

// Handle admin routes specifically
if (window.location.pathname.startsWith('/admin')) {
  console.log('Admin route detected at application startup');
  console.log('Admin route path:', window.location.pathname);
}

// Enable route change monitoring
monitorRouteChanges();

// Create root element if it doesn't exist (for testing environments)
const rootElement = document.getElementById('root') || document.createElement('div');
if (!rootElement.id) {
  rootElement.id = 'root';
  document.body.appendChild(rootElement);
}

// Mount the application with error boundary
try {
  createRoot(rootElement).render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
  console.log('App successfully mounted');
} catch (error) {
  console.error('Failed to mount application:', error);
  
  // Fallback UI for critical errors
  rootElement.innerHTML = `
    <div style="
      font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      text-align: center;
      padding: 20px;
    ">
      <h1>Something went wrong</h1>
      <p>We're experiencing technical difficulties. Please try again later.</p>
      <button onclick="window.location.reload()">Refresh</button>
    </div>
  `;
}
